var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"u-wrapper-panel"},[_c('video-player',{ref:"video",staticClass:"u-wrapper-panel",attrs:{"options":_vm.options},on:{"ready":_vm.onPlayerReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }